var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"position":"relative","height":"70vh"}},[_c('canvas',{ref:"submissions_over_time_canvas",attrs:{"role":"img","aria-label":"Submission score histogram"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }